import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getReview = async (id: string | undefined) => {
    const { data, error } = await supabase
        .from('reviews')
        .select(`*, user_profiles(full_name,avatar )`)
        .eq('salon', id)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetReviewBySalonId(id: string | undefined) {
    return useQuery({
        queryKey: ['useGetReviewBySalonId', id],
        queryFn: () => getReview(id || ''),
        staleTime: 0,
        enabled: !!id,
    })
}
